export default "__VITE_ASSET__ddd273d7__"